<template>
    <transition name="fade">
        <div class="theater" :class="{'mini': minimized}" v-if="theaterOpen">
            <div class="backdrop" @click="() => {closeTheater(true)}"></div>

            <transition name="fade">
                <div class="toast" v-if="toast">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none">
                        <path d="M12 7L12 13" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 17.01L12.01 16.9989" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    This stream is currently unavailable. Please try another.
                </div>
            </transition>

            <div class="video-container"
                :class="{ 'hide-cursor': isFullscreen && isCursorHidden, 'loading': loading }"
                @mousemove="handleMouseMove"
                @click="handleMouseMove"
                @touchend="handleContainerTouchEnd"
            >
                <video
                    ref="videoPlayer"
                    class="video-js vjs-big-play-centered"
                    playsinline
                ></video>

                <transition name="fade">
                    <button v-if="!isLastEp && vodType === 'tv' && (progressPercent && (progressPercent > 90))" @click="manualPlayNext" class="next-episode-btn" :class="{ 'show': showControls }">
                        Next Episode
                        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none"> <path d="M9 6L15 12L9 18" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                    </button>
                </transition>

                <div class="custom-controls" :class="{ 'show': showControls }"
                    @click.stop
                    @click="handleVideoClick"
                >
                    <div class="top-bar" v-if="!minimized" @click.stop>
                        <div class="first">
                            <button class="close-btn" @click="() => {closeTheater(true)}">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </button>
                            <div class="video-title">{{ currentTitle }}</div>

                        </div>

                        <div class="mini-btn" @click="minimize" v-if="!isFullscreen ">
                            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M6 9L12 15L18 9" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                        </div>
                    </div>

                    <transition name="fade">
                        <Loader v-if="loading"/>
                    </transition>

                    <transition name="fade">

                        <div v-if="minimized" class="mini-tools" @click.stop>
                            <button @click="minimize" class="control-btn float">
                                <svg width="125" height="125" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M6 15L12 9L18 15" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                            </button>

                            <button class="control-btn" @click="returnToSource">
                                <svg xmlns="http://www.w3.org/2000/svg" width="80px" height="80px" viewBox="0 0 24 24" fill="none"> <path d="M8 21H20.4C20.7314 21 21 20.7314 21 20.4V3.6C21 3.26863 20.7314 3 20.4 3H3.6C3.26863 3 3 3.26863 3 3.6V16" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3.5 20.5L12 12M12 12V16M12 12H8" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                            </button>

                            <button v-if="mode === 'live'" @click="wod(mode)" class="control-btn">
                                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none"> <path d="M17.5 8C17.5 8 19 9.5 19 12C19 14.5 17.5 16 17.5 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.5 5C20.5 5 23 7.5 23 12C23 16.5 20.5 19 20.5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M6.5 8C6.5 8 5 9.5 5 12C5 14.5 6.5 16 6.5 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3.5 5C3.5 5 1 7.5 1 12C1 16.5 3.5 19 3.5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                            </button>

                            <button @click="togglePlay" class="control-btn">
                                <svg v-if="!playing" width="80" height="80" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M8 5v14l11-7z"/>
                                </svg>
                                <svg v-else width="80" height="80" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/>
                                </svg>
                            </button>

                            <div class="volume-control">
                                <button @click="toggleMute" class="control-btn">
                                    <svg v-if="volume > 0.5" width="80" height="80" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                                    </svg>
                                    <svg v-else-if="volume > 0" width="80" height="80" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/>
                                    </svg>
                                    <svg v-else width="80" height="80" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
                                    </svg>
                                </button>
                            </div>

                        </div>

                    </transition>
                    <div class="bottom-controls" @click.stop v-if="!minimized">
                        <div class="progress-container" v-if="mode === 'od'"
                            @pointerdown="onProgressPointerDown"
                            @pointermove="onProgressPointerMove"
                            @pointerup="onProgressPointerUp"
                            @pointercancel="onProgressPointerCancel"
                            @pointerleave="onProgressPointerLeave"
                        >
                            <div class="progress-bar">
                                <div class="progress-filled" :style="{ width: progressPercent + '%' }"></div>
                            </div>
                            <div class="time-tooltip" v-if="showTimeTooltip" :style="{ left: hoverPercent + '%' }">
                                {{ hoverTimeFormatted }}
                            </div>
                        </div>

                        <div class="time-display" v-if="mode === 'od'" >
                            <span>{{ currentTimeFormatted }}</span>
                            <span>/</span>
                            <span>{{ durationFormatted }}</span>
                        </div>

                        <div class="controls-row">
                            <div class="controls-left">
                                <button v-if="mode === 'live'" @click="wod(mode)" class="control-btn">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none"> <path d="M17.5 8C17.5 8 19 9.5 19 12C19 14.5 17.5 16 17.5 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M20.5 5C20.5 5 23 7.5 23 12C23 16.5 20.5 19 20.5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M6.5 8C6.5 8 5 9.5 5 12C5 14.5 6.5 16 6.5 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M3.5 5C3.5 5 1 7.5 1 12C1 16.5 3.5 19 3.5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                </button>

                                <button @click="togglePlay" class="control-btn">
                                    <svg v-if="!playing" width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M8 5v14l11-7z"/>
                                    </svg>
                                    <svg v-else width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z"/>
                                    </svg>
                                </button>

                                <button @click="skipBackward" v-if="mode === 'live'" class="control-btn">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M11.99 5V1l-5 5 5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"/>
                                        <text x="12" y="16" text-anchor="middle" font-size="8" fill="white" font-weight="bold">10</text>
                                    </svg>
                                </button>

                                <button @click="skipForward" v-if="mode === 'live'" class="control-btn">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M12 5V1l5 5-5 5V7c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6h2c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8z"/>
                                        <text x="12" y="16" text-anchor="middle" font-size="8" fill="white" font-weight="bold">10</text>
                                    </svg>
                                </button>

                                <div class="volume-control">
                                    <button @click="toggleMute" class="control-btn">
                                        <svg v-if="volume > 0.5" width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
                                        </svg>
                                        <svg v-else-if="volume > 0" width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z"/>
                                        </svg>
                                        <svg v-else width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
                                        </svg>
                                    </button>
                                    <input
                                        @click.stop
                                        type="range"
                                        class="volume-slider"
                                        min="0"
                                        max="1"
                                        step="0.1"
                                        v-model="volume"
                                        @input="updateVolume"
                                    >
                                </div>
                            </div>

                            <div class="controls-right">
                                <div class="dropdown-menu" v-if="subtitles.length > 0">
                                    <button @click="toggleSubtitlesMenu" class="control-btn">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z"/>
                                        </svg>
                                    </button>
                                    <div class="dropdown-content" v-show="showSubtitlesMenu">
                                        <div class="dropdown-item" :class="{ active: activeSubtitleIndex === null }" @click="selectSubtitle(null)">
                                            <span>Off</span>
                                            <span class="checkmark" v-if="activeSubtitleIndex === null">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none"> <path d="M5 13L9 17L19 7" stroke="#e50914" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                            </span>
                                        </div>
                                        <div
                                            class="dropdown-item"
                                            v-for="(sub, index) in subtitles"
                                            :key="index"
                                            :class="{ active: activeSubtitleIndex === sub.index }"
                                            @click="selectSubtitle(sub.index)"
                                        >
                                            <span>{{ sub.language }}</span>
                                            <span class="checkmark" v-if="activeSubtitleIndex === sub.index">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none"> <path d="M5 13L9 17L19 7" stroke="#e50914" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="dropdown-menu" v-if="audioTracks.length > 1">
                                    <button @click="toggleAudioMenu" class="control-btn">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z"/>
                                        </svg>
                                    </button>
                                    <div class="dropdown-content" v-show="showAudioMenu">
                                        <div
                                            class="dropdown-item"
                                            v-for="(track, index) in audioTracks"
                                            :key="index"
                                            :class="{ active: activeAudioIndex === track.index }"
                                            @click="selectAudioTrack(track.index)"
                                        >
                                            <span>{{ track.language }}</span>
                                            <span class="checkmark" v-if="activeAudioIndex === index">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 24 24" fill="none"> <path d="M5 13L9 17L19 7" stroke="#e50914" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="dropdown-menu">
                                    <button @click="toggleSettingsMenu" class="control-btn">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94L14.4 2.81c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/>
                                        </svg>
                                    </button>
                                    <div class="dropdown-content" v-show="showSettingsMenu">
                                        <div class="dropdown-item" v-if="mode === 'od'" @click="toggleAutoplay">
                                            <span>Autoplay</span>
                                            <span class="checkmark" v-if="autoplay">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none"> <path d="M5 13L9 17L19 7" stroke="#e50914" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                            </span>
                                        </div>
                                        <div class="dropdown-item" :class="{ active: currentPlaybackRate === 0.5 }" @click="changePlaybackRate(0.5)">
                                            <span>Speed: 0.5x</span>
                                            <span class="checkmark" v-if="currentPlaybackRate === 0.5">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none"> <path d="M5 13L9 17L19 7" stroke="#e50914" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                            </span>
                                        </div>
                                        <div class="dropdown-item" :class="{ active: currentPlaybackRate === 1 }" @click="changePlaybackRate(1)">
                                            <span>Speed: 1x</span>
                                            <span class="checkmark" v-if="currentPlaybackRate === 1">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none"> <path d="M5 13L9 17L19 7" stroke="#e50914" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                            </span>
                                        </div>
                                        <div class="dropdown-item" :class="{ active: currentPlaybackRate === 1.25 }" @click="changePlaybackRate(1.25)">
                                            <span>Speed: 1.25x</span>
                                            <span class="checkmark" v-if="currentPlaybackRate === 1.25">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none"> <path d="M5 13L9 17L19 7" stroke="#e50914" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                            </span>
                                        </div>
                                        <div class="dropdown-item" :class="{ active: currentPlaybackRate === 1.5 }" @click="changePlaybackRate(1.5)">
                                            <span>Speed: 1.5x</span>
                                            <span class="checkmark" v-if="currentPlaybackRate === 1.5">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none"> <path d="M5 13L9 17L19 7" stroke="#e50914" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                            </span>
                                        </div>
                                        <div class="dropdown-item" :class="{ active: currentPlaybackRate === 2 }" @click="changePlaybackRate(2)">
                                            <span>Speed: 2x</span>
                                            <span class="checkmark" v-if="currentPlaybackRate === 2">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" fill="none"> <path d="M5 13L9 17L19 7" stroke="#e50914" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <button @click="toggleFullscreen" class="control-btn">
                                    <svg v-if="!isFullscreen" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
                                    </svg>
                                    <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                        <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"/>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import mpegts from 'mpegts.js';
const Loader = () => import('@/components/Loader')

export default {
    name: 'wod',
    props: {},

    components: {
        Loader
    },

    data() {
        return {
            cid: null,
            clickTimeout: null,
            mode: '',
            vodType: '',
            url: '',
            theaterOpen: false,
            player: null,
            mpegtsPlayer: null,
            currentTitle: '',
            toast: false,
            sourcePath: '',

            // HLS session tracking
            sessionId: null,
            isSeekingTranscode: false,
            transcodeStartTime: 0,
            transcodeBuffered: 0,

            // Player state
            playing: false,
            currentTime: 0,
            duration: 0,
            volume: 1,
            isFullscreen: false,
            currentPlaybackRate: 1,

            // UI state
            showControls: true,
            controlsTimeout: null,
            showTimeTooltip: false,
            hoverPercent: 0,
            hoverTime: 0,
            scrubbingProgress: false,

            // Menus
            showSubtitlesMenu: false,
            showAudioMenu: false,
            showSettingsMenu: false,

            // Tracks
            subtitles: [],
            audioTracks: [],
            activeSubtitleIndex: null,
            activeAudioIndex: 0,

            // Episode navigation
            loading: false,
            isCursorHidden: false,
            cursorHideTimeout: null,
            autoplay: true,
            nextPromptShown: false,
            minimized: false,

            isLastEp: false
        }
    },
    computed: {
        progressPercent() {
            if (!this.duration || !isFinite(this.duration) || this.duration <= 0) return 0;
            const dur = (this.currentTime / this.duration) * 100
            return dur
        },
        currentTimeFormatted() {
            return this.formatTime(this.currentTime);
        },
        durationFormatted() {
            return this.formatTime(this.duration);
        },
        hoverTimeFormatted() {
            return this.formatTime(this.hoverTime);
        },
        anyMenuOpen() {
            return this.showSubtitlesMenu || this.showAudioMenu || this.showSettingsMenu;
        }
    },
    watch: {
        showSubtitlesMenu() { this.resetControlsTimeout(); },
        showAudioMenu() { this.resetControlsTimeout(); },
        showSettingsMenu() { this.resetControlsTimeout(); },
        scrubbingProgress() { this.resetControlsTimeout(); }
    },
    methods: {
        returnToSource(){
            this.$router.push(this.sourcePath)
        },
        minimize(){
            this.minimized = !this.minimized
            if(this.minimized){
                this.togglePlay()
            }
        },
        handleVideoClick() {
            if (event.pointerType === 'mouse') {
                this.togglePlay()
                return
            }

            if (this.showSubtitlesMenu || this.showAudioMenu || this.showSettingsMenu) {
                this.showSubtitlesMenu = false;
                this.showAudioMenu = false;
                this.showSettingsMenu = false;
                return;
            }

            if (this.clickTimeout) {
                clearTimeout(this.clickTimeout);
                this.clickTimeout = null;
                this.toggleFullscreen();
            } else {
                this.clickTimeout = setTimeout(() => {
                    this.showControls = false;
                    clearTimeout(this.controlsTimeout);
                    this.clickTimeout = null;
                }, 250);
            }
        },

        handleKeyDown(e) {
            if (!this.theaterOpen) return;

            const activeEl = document.activeElement;
            const isTypingTarget = activeEl && (activeEl.tagName === 'INPUT' || activeEl.tagName === 'TEXTAREA' || activeEl.isContentEditable);
            if (isTypingTarget) return;

            if (e.code === 'Space') {
                e.preventDefault();
                this.togglePlay();
                return;
            }

            if (e.code === 'ArrowLeft' && this.mode === 'od') {
                e.preventDefault();
                this.player.currentTime(Math.max(0, this.player.currentTime() - 5));
                return;
            }

            if (e.code === 'ArrowRight' && this.mode === 'od') {
                e.preventDefault();
                this.player.currentTime(Math.min(this.duration, this.player.currentTime() + 5));
                return;
            }

            if (e.code === 'ArrowUp') {
                e.preventDefault();
                this.volume = Math.min(1, Math.round((this.volume + 0.1) * 100) / 100);
                this.updateVolume();
                return;
            }

            if (e.code === 'ArrowDown') {
                e.preventDefault();
                this.volume = Math.max(0, Math.round((this.volume - 0.1) * 100) / 100);
                this.updateVolume();
                return;
            }
        },

        initIPTVPlayer(videoSrc, videoElement) {
            if (mpegts.isSupported()) {
                this.mpegtsPlayer = mpegts.createPlayer({
                    type: 'mpegts',
                    isLive: true,
                    url: videoSrc
                });
                this.mpegtsPlayer.attachMediaElement(videoElement);
                this.mpegtsPlayer.load();
                this.mpegtsPlayer.play();
                this.mpegtsPlayer.on(mpegts.Events.ERROR, (errorType, errorDetail) => {
                    console.log('mpegts error', errorType, errorDetail);
                    if (errorType === mpegts.ErrorTypes.NETWORK_ERROR) {
                        const currentTime = videoElement.currentTime;
                        this.mpegtsPlayer.unload();
                        this.mpegtsPlayer.load();
                        videoElement.currentTime = currentTime;
                        this.mpegtsPlayer.play();
                    }
                });
            }
        },

        initPlayer(videoSrc) {
            const videoElement = this.$refs.videoPlayer;

            this.player = window.videojs(videoElement, {
                controls: false,
                autoplay: true,
                preload: 'auto',
                fluid: true,
                responsive: true,
                textTrackDisplay: {
                    allowMultipleShowingTracks: false
                },
                html5: {
                    vhs: {
                        overrideNative: true,
                        withCredentials: false
                    },
                    nativeTextTracks: true,
                    nativeAudioTracks: false,
                    nativeVideoTracks: false
                }
            });


            if(this.mode === 'live'){
                this.initIPTVPlayer(videoSrc, videoElement)
            }else{
                this.player.src({
                    src: videoSrc,
                    type: this.getVideoType(videoSrc)
                });
            }

            // Event listeners
            this.player.one('ready', () => {
                if(this.mode === 'od'){
                    this.player.currentTime(0)
                    this.loading = false
                }
            })

            this.player.on('play', () => {
                this.playing = true;
                this.resetControlsTimeout();
                this.$root.$emit('theaterEvent');
            });
            this.player.on('pause', () => {
                this.playing = false;
                this.showControls = true;
                clearTimeout(this.controlsTimeout);
                this.$root.$emit('theaterEvent', true);
            });

            if(this.vodType === 'tv'){
                this.player.on('ended', () => {
                    if (this.autoplay) { this.autoPlayNext() }
                });
            }

            this.player.on('timeupdate', () => {
                if(this.isSeekingTranscode) return;
                this.currentTime = this.player.currentTime() + this.transcodeStartTime;

                if (this.player.buffered().length > 0) {
                    const bufferedEnd = this.player.buffered().end(this.player.buffered().length - 1);
                    this.transcodeBuffered = this.transcodeStartTime + bufferedEnd;
                }
            });

            // Initial controls timeout
            this.resetControlsTimeout();
        },

        getVideoType(url) {
            if (url.includes('.m3u8')) return 'application/x-mpegURL';
            return 'video/mp4';
        },



        togglePlay() {
            if(!this.player){return}
            if (this.player.paused()) {
                this.player.play();
            } else {
                this.player.pause();
            }
        },

        skipBackward() {
            this.player.currentTime(Math.max(0, this.player.currentTime() - 10));
            this.resetControlsTimeout();
        },

        skipForward() {
            this.player.currentTime(Math.min(this.duration, this.player.currentTime() + 10));
            this.resetControlsTimeout();
        },

        seek(event) {
            if (this.isSeekingTranscode) return;

            const rect = event.currentTarget.getBoundingClientRect();
            const percent = (event.clientX - rect.left) / rect.width;
            const seekTime = percent * this.duration;

            this.$root.$emit('theaterEvent');

            if (this.url) {
                const buffered = this.player.buffered();
                let isWithinBuffer = false;

                for (let i = 0; i < buffered.length; i++) {
                    const start = this.transcodeStartTime + buffered.start(i);
                    const end = this.transcodeStartTime + buffered.end(i);

                    if (seekTime >= start && seekTime <= end) {
                        isWithinBuffer = true;
                        break;
                    }
                }

                if (!isWithinBuffer) {
                    this.seekTranscode(seekTime);
                    return
                }

                this.player.currentTime(seekTime);
                return;
            }
            // Normal seek for non-HLS
            this.player.currentTime(seekTime);
            this.currentTime = seekTime;
        },

        async seekTranscode(seekTime) {
            if (!this.url || this.isSeekingTranscode) return;

            this.isSeekingTranscode = true;
            this.player.pause();
            this.currentTime = seekTime;

            try {
                this.loading = true
                const response = await fetch(process.env.VUE_APP_PROXY + '/transcode-seek', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        sessionId: this.sessionId,
                        seekTime: seekTime,
                        videoUrl: this.url,
                        audioIndex: this.activeAudioIndex,
                        subtitleIndex: this.activeSubtitleIndex
                    })
                });

                const data = await response.json();

                if (data.playlist) {
                    this.sessionId = data.sessionId;
                    this.transcodeStartTime = seekTime;
                    this.transcodeBuffered = seekTime;
                    this.activeSubtitleIndex = data.subtitleIndex;

                    this.player.src({
                        src: data.playlist,
                        type: 'application/x-mpegURL'
                    });

                    this.isSeekingTranscode = false;
                    this.loading = false
                }
            } catch (error) {
                console.error('Seek transcode failed:', error);
                this.isSeekingTranscode = false;
                this.player.play();
            }
        },

        updateHoverTime(event) {
            const rect = event.currentTarget.getBoundingClientRect();
            this.hoverPercent = ((event.clientX - rect.left) / rect.width) * 100;
            this.hoverTime = (this.hoverPercent / 100) * this.duration;
            this.showTimeTooltip = true;
        },

        hideHoverTime() {
            this.showTimeTooltip = false;
            this.hoverPercent = 0;
        },

        onProgressPointerDown(event) {
            if (this.isSeekingTranscode) return;
            this.scrubbingProgress = true;
            this.$root.$emit('theaterEvent');
            if (event.currentTarget.setPointerCapture) {
                try { event.currentTarget.setPointerCapture(event.pointerId); } catch (e) { /* noop */ }
            }
            this.updateHoverTime(event);
        },

        onProgressPointerMove(event) {
            if (this.scrubbingProgress || event.pointerType === 'mouse') {
                this.updateHoverTime(event);
            }
        },

        onProgressPointerUp(event) {
            if (!this.scrubbingProgress) return;
            this.scrubbingProgress = false;
            this.seek(event);
            if (event.pointerType !== 'mouse') {
                this.hideHoverTime();
            }
        },

        onProgressPointerCancel() {
            this.scrubbingProgress = false;
            this.hideHoverTime();
        },

        onProgressPointerLeave() {
            if (!this.scrubbingProgress) {
                this.hideHoverTime();
            }
        },

        toggleMute() {
            if (this.player.muted()) {
                this.player.muted(false);
                this.volume = this.player.volume();
            } else {
                this.player.muted(true);
                this.volume = 0;
            }
            this.resetControlsTimeout();
        },

        updateVolume() {
            this.player.volume(this.volume);
            this.player.muted(this.volume === 0);
            this.resetControlsTimeout();
        },

        toggleFullscreen() {
            const container = this.$el.querySelector('.video-container');

            this.resetControlsTimeout();
            if (!document.fullscreenElement) {
                this.isFullscreen = true;
                container.requestFullscreen();
                this.handleCursorInactivity();
                this.minimized = false
            } else {
                this.isFullscreen = false;
                this.isCursorHidden = false;
                clearTimeout(this.cursorHideTimeout);
                document.exitFullscreen();
            }

            this.player.play()
        },

        toggleSubtitlesMenu() {
            this.showSubtitlesMenu = !this.showSubtitlesMenu;
            this.showAudioMenu = false;
            this.showSettingsMenu = false;
        },

        toggleAudioMenu() {
            this.showAudioMenu = !this.showAudioMenu;
            this.showSubtitlesMenu = false;
            this.showSettingsMenu = false;
        },

        toggleSettingsMenu() {
            this.showSettingsMenu = !this.showSettingsMenu;
            this.showSubtitlesMenu = false;
            this.showAudioMenu = false;
        },

        toggleAutoplay() {
            this.autoplay = !this.autoplay;
        },

        async selectSubtitle(index) {
            if (!this.player || this.activeSubtitleIndex === index) {
                this.showSubtitlesMenu = false;
                return;
            }

            this.activeSubtitleIndex = index;
            this.showSubtitlesMenu = false;

            const resumeTime = this.transcodeStartTime + this.player.currentTime();
            await this.seekTranscode(resumeTime);

            this.$nextTick(() => {
                this.player.trigger('texttrackchange');
                this.player.trigger('resize');
                setTimeout(() => {
                    this.player.trigger('resize');
                }, 50);
            });
        },

        async selectAudioTrack(index) {
            if (!this.player || this.activeAudioIndex === index) {
                this.showAudioMenu = false;
                return;
            }

            this.activeAudioIndex = index;
            this.showAudioMenu = false;

            const resumeTime = this.transcodeStartTime + this.player.currentTime();
            await this.seekTranscode(resumeTime);
        },

        changePlaybackRate(rate) {
            this.player.playbackRate(rate);
            this.currentPlaybackRate = rate;
            this.showSettingsMenu = false;
        },

        handleCursorInactivity() {
            this.isCursorHidden = false;
            clearTimeout(this.cursorHideTimeout);
            this.cursorHideTimeout = setTimeout(() => {
                if (this.isFullscreen) {
                    this.isCursorHidden = true;
                }
            }, 3000);
        },

        handleMouseMove(prompt=false) {
            if(prompt === true){
                this.nextPromptShown = true
            }

            this.showControls = true;
            this.resetControlsTimeout();

            if (this.isFullscreen) {
                this.handleCursorInactivity();
            }
        },

        handleContainerMouseMove(event){
            if (event.pointerType === 'mouse') {
                this.togglePlay()
                return
            }
            this.handleMouseMove()

        },
        handleContainerTouchEnd(event) {
            if (event.pointerType === 'mouse') {
                this.togglePlay()
                return
            }

            if (this.showControls) return;

            event.preventDefault();
            this.handleMouseMove();
        },

        resetControlsTimeout() {
            clearTimeout(this.controlsTimeout);
            if (this.playing && !this.anyMenuOpen && !this.scrubbingProgress) {
                this.controlsTimeout = setTimeout(() => {
                    this.showControls = false;
                }, 3000);
            }
        },

        formatTime(seconds) {
            if (!seconds || isNaN(seconds) || !isFinite(seconds)) return '0:00';
            const hours = Math.floor(seconds / 3600);
            const mins = Math.floor((seconds % 3600) / 60);
            const secs = Math.floor(seconds % 60);

            if (hours > 0) {
                return `${hours}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
            }
            return `${mins}:${secs.toString().padStart(2, '0')}`;
        },

        previousEpisode() {
            this.$emit('previous-episode');
        },

        nextEpisode() {
            this.$emit('nextEpisode');
        },

        closePIP() {
            if (document.pictureInPictureElement) {
                document.exitPictureInPicture()
            }
        },

        async handleBeforeUnload() {
            if(this.sessionId){
                if(this.mode === 'live'){
                    await window.navigator.sendBeacon(`${process.env.VUE_APP_PROXY}/iptv-stop?sessionId=${this.sessionId}`);
                }else{
                    await window.navigator.sendBeacon(`${process.env.VUE_APP_PROXY}/transcode-stop?sessionId=${this.sessionId}`);
                }
            }else{
                if(this.mode === 'live'){
                    await window.navigator.sendBeacon(`${process.env.VUE_APP_PROXY}/iptv-client-stop?clientId=${this.cid}`);
                }else{
                    await window.navigator.sendBeacon(`${process.env.VUE_APP_PROXY}/transcode-stop?clientId=${this.cid}`);
                }

            }
        },
        closeTheater(manual=false) {
            this.handleBeforeUnload();

            if (this.mpegtsPlayer) {
                try {
                    this.mpegtsPlayer.pause();
                    this.mpegtsPlayer.unload();
                    this.mpegtsPlayer.detachMediaElement();
                    this.mpegtsPlayer.destroy();
                } catch (e) {
                    console.warn('mpegts cleanup error:', e);
                }
                this.mpegtsPlayer = null;
            }

            // Then tear down videojs
            if (this.player) {
                try {
                    this.player.pause();
                    this.player.reset();
                    this.player.dispose();
                } catch (e) {
                    console.warn('videojs cleanup error:', e);
                }
                this.player = null;
            }

            // Exit fullscreen if active
            if (document.fullscreenElement) {
                document.exitFullscreen().catch(() => {});
            }

            this.closePIP();

            // Clear all timeouts
            clearTimeout(this.controlsTimeout);
            clearTimeout(this.cursorHideTimeout);
            clearTimeout(this.clickTimeout);
            this.controlsTimeout = null;
            this.cursorHideTimeout = null;
            this.clickTimeout = null;

            // Reset all state to initial values
            this.mode = '';
            this.vodType = '';
            this.currentTitle = '';
            this.url = '';
            this.sourcePath = '';
            this.playing = false;
            this.currentTime = 0;
            this.duration = 0;
            this.volume = 1;
            this.isFullscreen = false;
            this.currentPlaybackRate = 1;
            this.toast = false;
            this.isSeekingTranscode = false;
            this.transcodeStartTime = 0;
            this.transcodeBuffered = 0;
            this.sessionId = null;
            this.nextPromptShown = false;
            this.showControls = true;
            this.isCursorHidden = false;
            this.minimized = false;
            this.isLastEp = false;
            this.loading = false;

            // Reset UI state
            this.showSubtitlesMenu = false;
            this.showAudioMenu = false;
            this.showSettingsMenu = false;
            this.showTimeTooltip = false;
            this.hoverPercent = 0;
            this.hoverTime = 0;

            // Reset tracks
            this.subtitles = [];
            this.audioTracks = [];
            this.activeSubtitleIndex = null;
            this.activeAudioIndex = 0;

            this.$nextTick(() => {
                this.theaterOpen = false;
            });

            if (manual) {
                this.$root.$emit('theaterClosed');
            }
        },
        setMetaData(title, artwork) {
            this.currentTitle = title;
            if ('mediaSession' in navigator) {
                navigator.mediaSession.metadata = new window.MediaMetadata({
                    title: title,
                    artwork: [{ src: artwork, type: 'image' }]
                });
            }
        },

        recordInLocalStorage() {
            const obj = {
                id: window.showId,
                episode: window.episode,
                season: window.season
            };

            const STORAGE_KEY = 'WODHistory';
            const list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
            const existingIndex = list.findIndex(item => item.id === obj.id);

            if (existingIndex !== -1) {
                list[existingIndex] = obj;
            } else {
                list.push(obj);
            }

            localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
        },


        async wod(mode) {
            this.cid = window.localStorage.getItem('cid')
            if(this.player|| this.mpegtsPlayer){
                this.closeTheater()
                await new Promise(resolve => setTimeout(resolve, 500));
                await this.$nextTick();
            }

            await this.$nextTick()

            this.mode = mode;
            const params = this.$parent.didParams;
            this.$parent.didOpen = false;

            this.sourcePath = window.location.pathname

            if (mode === 'live') {
                this.theaterOpen = true;
                this.$nextTick(async () => {
                    this.loading = true

                    const iptvUrl = `${process.env.VUE_APP_PROXY}/iptv-start`;
                    const d = await fetch(iptvUrl, {method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({url: params.url, cid: this.cid })
                    })
                    const data  = await d.json()

                    const videoSrc = data.url;
                    this.url = videoSrc;
                    this.sessionId = data.sessionId;
                    this.initPlayer(videoSrc);
                    this.loading = false
                });

                this.setMetaData(params.title, params.artwork);

            }

            if (mode.includes('od')) {
                this.vodType = this.$route.path.includes('/tv/') ? 'tv' : 'movie';
                const download = mode.includes('save');
                if (!download) { this.theaterOpen = true; }

                this.$nextTick(async () => {
                    const response = await window.afetch(`/mag`, {
                        method: 'POST',
                        body: JSON.stringify({
                            noArchive: true,
                            mag: params.url,
                            e: window.episode || 0,
                            s: window.season || 0
                        })
                    });
                    const streamURLData = await response.text();

                    const streamURLNotAvail = (streamURLData === null || streamURLData === undefined || streamURLData === '')
                    if (download) {
                        if(streamURLNotAvail){
                            alert('This stream is currently unavailable. Please try another.')
                            return
                        }

                        const fileUrl = `${process.env.VUE_APP_PROXY}/download?url=${encodeURIComponent(streamURLData)}`;
                        const a = document.createElement('a');
                        a.href = fileUrl;
                        document.body.appendChild(a);
                        a.click();
                        a.remove();
                    } else {
                        if(streamURLNotAvail){
                            this.toast = true
                            this.$root.$emit('streamError');
                            setTimeout(() => { this.closeTheater() }, 3000)
                            return
                        }

                        this.loading = true
                        this.url = streamURLData;

                        const videoSrc = `${process.env.VUE_APP_PROXY}/transcode-video`;
                        const d = await fetch(videoSrc, {method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({url: streamURLData, cid: this.cid}),
                        })

                        const data  = await d.json()

                        this.initPlayer(data.playlist);
                        this.duration = data.duration;
                        this.sessionId = data.sessionId;
                        this.activeAudioIndex = data.audioIndex
                        this.activeSubtitleIndex = null

                        this.subtitles = data.subtitleTracks
                        this.audioTracks = data.audioTracks

                        this.pendingSubtitleLookup = (data.subtitleIndex === null || data.subtitleIndex === undefined)
                            ? { videoUrl: streamURLData, title: params.title, season: params.season, episode: params.episode }
                            : null;

                        let title = params.title
                        if(params.episode && params.season){
                            title = `${title} S${params.season}:E${params.episode}`
                        }
                        this.setMetaData(title, params.artwork);
                        this.recordInLocalStorage();
                    }
                });
            }
        },

        handlePlayerEvent(payload) {
            if(!this.player) {
                setTimeout(() => { this.handlePlayerEvent(payload) }, 1000)
            }
            if(payload === 'play') this.player.play();
            if(payload === 'pause') this.player.pause();
        },

        manualPlayNext(){
            this.autoPlayNext()
            this.$root.$emit('theaterEvent');
        },

        autoPlayNext(){
            this.$root.$emit('nextEpisode');
            this.closeTheater()
        }
    },

    mounted() {
        this.$root.$on('wod', ({ mode, last = false}) => {
            this.wod(mode);
            this.isLastEp = last
        });
        this.$root.$on('closeTheater', this.closeTheater);
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        window.addEventListener('keydown', this.handleKeyDown);
        this.$root.$on('playerEvent', this.handlePlayerEvent);
    },

    beforeDestroy() {
        this.$root.$off('wod');
        this.$root.$off('closeTheater', this.closeTheater);
        this.closeTheater();
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        window.removeEventListener('keydown', this.handleKeyDown);
        this.$root.$off('playerEvent', this.handlePlayerEvent);
        if (this.player) {
            this.player.dispose();
        }
        clearTimeout(this.controlsTimeout);
        clearTimeout(this.cursorHideTimeout);
    }
}
</script>

<style scoped lang="scss">
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}

.toast{
  top: 20vh;
  left: 50vw;
  transform: translateX(-50%);
  position: absolute;
  padding: 1.5%;
  z-index: 9999999999;
  background-color: rgba(231, 76, 60,0.2);
  color: white;
  font-weight: bold;
  border-radius: 10px;
  backdrop-filter: blur(5px);
  display: flex;
  align-items: center;
    svg{
        margin-right: 12px;
    }
}

.theater {
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    &.mini{
        bottom: 20px;
        left: -15px;
        top: unset;
        transform: scale(0.3);
        transition-duration: 0.3s;
        transform-origin: bottom right;
        right: unset;
        overflow: hidden;

        @media (max-width: 700px) {
            bottom: -25vh;
            left: -15px;
            top: unset;
            transform: scale(0.85);
        }
        .video-container{
            width: 100%;
            height: auto;
            &.loading{
                min-height: 60vh;
            }
        }
        .video-js{
            overflow: hidden;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
        }
        .backdrop{
            display: none;
            opacity: 0;
        }

    }

    .backdrop {
        position: fixed;
        width: 100vw;
        height: 100vh;
        z-index: -1;
        background-color: rgba(0, 0, 0, 0.95);
    }

    .video-container {
        width: 90vw;
        height: 90vh;
        position: relative;
        z-index: 3;

        &.hide-cursor {
            cursor: none;
        }

        .video-js {
            width: 100%;
            height: 100%;
            .vjs-tech{
                object-fit: contain;
            }
       }
    }

    // Outside mini mode, the container's box (90vw x 90vh) is the source of truth
    // for sizing - override video.js's fluid padding-top hack (which sizes itself
    // from the video's native ratio + its own width, ignoring container height)
    // so the player can never grow taller/wider than the container.
    &:not(.mini) {
        .video-container .video-js {
            &.vjs-fluid,
            &.vjs-16-9,
            &.vjs-4-3 {
                padding-top: 0 !important;
                height: 100% !important;
            }
        }
    }

    .custom-controls {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        opacity: 0;
        z-index: 10;
        transition: opacity 0.3s ease;
        cursor: default;
        touch-action: manipulation;

        &.show {
            opacity: 1;
            pointer-events: all;
            z-index: 9;
        }

        * {
            pointer-events: all;
        }

        .mini-tools{
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.7);
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 100px;
            .float{
                position: absolute;
                top: 0;
                right: calc(50% - 55px);
                padding: 60px 0;
            }

        }
    }

    .top-bar {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        padding: 20px;
        background: linear-gradient(180deg, rgba(0,0,0,0.7) 0%, transparent 100%);
        display: flex;
        align-items: center;
        gap: 15px;
        justify-content: space-between;
        z-index: 10;
        .first{
            display:flex;
            align-items: center;
            gap: 20px;
        }
        .mini-btn{
            cursor: pointer;
            justify-self: end;
            touch-action: manipulation;
            -webkit-tap-highlight-color: transparent;
        }

        .close-btn {
            background: none;
            border: none;
            color: white;
            cursor: pointer;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: transform 0.2s;
            touch-action: manipulation;
            -webkit-tap-highlight-color: transparent;

            &:hover {
                transform: scale(1.1);
            }
        }

        .video-title {
            font-size: 18px;
            font-weight: 600;
            color: white;
            text-shadow: 0 2px 4px rgba(0,0,0,0.5);
        }
    }

    .bottom-controls {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 0 20px 20px;
        background: linear-gradient(0deg, rgba(0,0,0,0.7) 0%, transparent 100%);
        z-index: 10;
    }

    .progress-container {
        width: 100%;
        padding: 10px 0 5px;
        cursor: pointer;
        position: relative;
        touch-action: none;
        -webkit-tap-highlight-color: transparent;

        .progress-bar {
            width: 100%;
            height: 4px;
            background: rgba(255, 255, 255, 0.3);
            border-radius: 2px;
            position: relative;
            transition: height 0.2s;

            &:hover {
                height: 6px;

                .progress-handle {
                    opacity: 1;
                    transform: translateX(-50%) scale(1);
                }
            }
        }

        .progress-filled {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
            background: #e50914;
            border-radius: 2px;
            pointer-events: none;
        }

        .progress-handle {
            position: absolute;
            top: 50%;
            transform: translateX(-50%) translateY(-50%) scale(0);
            width: 14px;
            height: 14px;
            background: #e50914;
            border-radius: 50%;
            border: 2px solid white;
            pointer-events: none;
            opacity: 0;
            transition: opacity 0.2s, transform 0.2s;
        }

        .time-tooltip {
            position: absolute;
            bottom: 100%;
            transform: translateX(-50%);
            margin-bottom: 8px;
            background: rgba(0, 0, 0, 0.9);
            color: white;
            padding: 5px 10px;
            border-radius: 4px;
            font-size: 12px;
            white-space: nowrap;
            pointer-events: none;
            z-index: 10;
        }
    }

    .time-display {
        display: flex;
        gap: 5px;
        color: white;
        font-size: 13px;
        font-weight: 500;
        white-space: nowrap;
        margin-top: 8px;
        padding-left: 2px;
    }

    .controls-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
    }

    .controls-left,
    .controls-right {
        display: flex;
        align-items: center;
        gap: 10px;
    }

    .control-btn {
        background: none;
        border: none;
        color: white;
        cursor: pointer;
        padding: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.2s, opacity 0.2s;
        opacity: 0.9;
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;

        &:hover {
            transform: scale(1.15);
            opacity: 1;
        }

        &:active {
            transform: scale(0.95);
        }
    }

    .volume-control {
        display: flex;
        align-items: center;
        gap: 8px;

        .volume-slider {
            width: 80px;
            height: 4px;
            background: rgba(255, 255, 255, 0.3);
            border-radius: 2px;
            outline: none;
            cursor: pointer;
            -webkit-appearance: none;

            &::-webkit-slider-thumb {
                -webkit-appearance: none;
                appearance: none;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background: white;
                cursor: pointer;
                transition: transform 0.2s;

                &:hover {
                    transform: scale(1.2);
                }
            }

            &::-moz-range-thumb {
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background: white;
                cursor: pointer;
                border: none;
                transition: transform 0.2s;

                &:hover {
                    transform: scale(1.2);
                }
            }
        }
    }

    .dropdown-menu {
        position: relative;

        .dropdown-content {
            position: absolute;
            bottom: 100%;
            right: 0;
            margin-bottom: 10px;
            background: rgba(0, 0, 0, 0.95);
            border-radius: 6px;
            padding: 8px 0;
            min-width: 150px;
            max-height: 300px;
            overflow-y: auto;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);

            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-track {
                background: rgba(255, 255, 255, 0.1);
                border-radius: 3px;
            }

            &::-webkit-scrollbar-thumb {
                background: rgba(255, 255, 255, 0.3);
                border-radius: 3px;

                &:hover {
                    background: rgba(255, 255, 255, 0.5);
                }
            }
        }

        .dropdown-item {
            padding: 10px 15px;
            color: white;
            font-size: 14px;
            cursor: pointer;
            transition: background 0.2s;
            display: flex;
            justify-content: space-between;
            align-items: center;
            touch-action: manipulation;
            -webkit-tap-highlight-color: transparent;

            &:hover {
                background: rgba(255, 255, 255, 0.1);
            }

            &.active {
                color: #e50914;
                font-weight: 600;
            }

            .checkmark {
                color: #e50914;
                font-size: 16px;
                margin-left: 10px;
            }
        }
    }
}

@media (max-width: 768px) {
    .theater {
        .video-container {
            width: 100vw;
            height: 100vh;
        }

        .controls-left,
        .controls-right {
            gap: 5px;
        }

        .control-btn {
            padding: 6px;
            min-width: 44px;
            min-height: 44px;

            svg {
                width: 20px;
                height: 20px;
            }
        }

        .volume-control {
            .volume-slider {
                width: 50px;

                &::-webkit-slider-thumb {
                    width: 16px;
                    height: 16px;
                }

                &::-moz-range-thumb {
                    width: 16px;
                    height: 16px;
                }
            }
        }

        .time-display {
            font-size: 12px;
        }
    }
}

.next-episode-btn{
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 4px;
    outline: none;
    border: none;
    background-color: white;
    padding: 5px 10px;
    padding-left: 20px;
    position: absolute;
    bottom: 120px;
    z-index: 10;
    cursor: pointer;
    right: 0;
    font-weight: bold;
    margin: 20px;
    transition-duration: 0.3s;
    pointer-events: none;
    opacity: 0;
    &.show{
        pointer-events: all;
        opacity: 0.3;
    }
    &:hover{
        opacity: 1;
    }
    svg{
        padding-left: 5px;
    }
}
</style>
